import { render, staticRenderFns } from "./SuricataAlertsTable.vue?vue&type=template&id=e1def2f2&"
import script from "./SuricataAlertsTable.vue?vue&type=script&lang=js&"
export * from "./SuricataAlertsTable.vue?vue&type=script&lang=js&"
import style0 from "./SuricataAlertsTable.vue?vue&type=style&index=0&id=e1def2f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports